import React, { useEffect } from 'react';
import './ContactUs.css';
import { motion } from 'framer-motion';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import GoogleFixedAds from '../../components/googleAds/GoogleFixedads';
import { GOOGLE_ADS_CLIENT } from '../../lib/config';

const ContactUs = () => {
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'contact_page_view', {
        event_category: 'Contact',
        event_label: 'Contact Us Page'
      });
    }
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (window.gtag) {
      window.gtag('event', 'contact_form_submit', {
        event_category: 'Contact',
        event_label: 'Contact Form Submission'
      });
    }
    // Optionally, add your form submission logic here
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | LED Scroller</title>
        <meta name="description" content="Contact LED Scroller for support, business inquiries, or feedback. Find our address, email, phone, and contact form here." />
        <meta property="og:title" content="Contact Us | LED Scroller" />
        <meta property="og:description" content="Contact LED Scroller for support, business inquiries, or feedback. Find our address, email, phone, and contact form here." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ledscroller.com/contact" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Us",
            "url": "https://ledscroller.com/contact",
            "contactOption": ["customer support"],
            "email": "usercontactcare@gmail.com",
            "telephone": "+1 (555) 123-****",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "123 opp. J H Ambani School, Piplod, Surat",
              "addressLocality": "Surat",
              "addressRegion": "Gujarat",
              "postalCode": "395007",
              "addressCountry": "India"
            }
          }
        `}</script>
      </Helmet>
      <div className="contact-page">
        <motion.div 
          className="contact-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          >
          <h1>Contact Us</h1>
          <p>Get in touch with us for any queries or support<br/>
            <Link to="/about">About Us</Link> | <Link to="/blog">Blog</Link>
          </p>
        </motion.div>
        <div className='col-12 d-flex justify-content-center'>
          <div className='google-ads-container'>
            <div className='google-ads-responsive'>
              <GoogleFixedAds
                style={{ display: 'block', width: '100%', height: 'auto' }}
                client={GOOGLE_ADS_CLIENT}
                slot="2305676975"
                format="auto"
                fullWidthResponsive={true}
              />    
            </div>
          </div>
        </div>

        <div className="contact-content">
          <div className="contact-grid">
            {/* Office Address Card */}
            <motion.div 
              className="contact-card"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="card-icon">
                <LocationOnIcon style={{ fontSize: 40, color: '#007bff' }} />
              </div>
              <h2>Office Address</h2>
              <div className="card-content">
                <p className="company-name">LED Scroller Headquarters</p>
                <p>123 opp. J H Ambani School, </p>
                <p>Piplod, Surat, </p>
                <p>Gujarat 395007</p>
                <p>India</p>
              </div>
            </motion.div>

            {/* Contact Information Card */}
            <motion.div 
              className="contact-card"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="card-icon">
                <ContactPhoneIcon style={{ fontSize: 40, color: '#007bff' }} />
              </div>
              <h2>Contact Information</h2>
              <div className="card-content">
                <div className="contact-item">
                  <EmailIcon className="contact-icon" style={{ color: '#007bff' }} />
                  <a href="mailto:usercontactcare@gmail.com">usercontactcare@gmail.com</a>
                </div>
                <div className="contact-item">
                  <PhoneIcon className="contact-icon" style={{ color: '#007bff' }} />
                  <a href="tel:+1555123">+1 (555) 123-****</a>
                </div>
                <div className="contact-item">
                  <AccessTimeIcon className="contact-icon" style={{ color: '#007bff' }} />
                  <span>Mon-Fri, 9:00 AM - 6:00 PM EST</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Map Section */}
          <motion.div 
            className="map-section"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <h2>Our Location</h2>
            <div className="map-container">
              
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.0501670637263!2d72.7683044487631!3d21.150401733556635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d89a1b7c795%3A0xec763af624c66f83!2sUdhana%20-%20Magdalla%20Rd%2C%20Vesu%2C%20Surat%2C%20Gujarat%20395007!5e0!3m2!1sen!2sin!4v1745779519374!5m2!1sen!2sin"
                width="100%"
                height="450"
                title="LED Scroller Location"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div 
            className="contact-form-section"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <h2>Send us a Message</h2>
            <form className="contact-form" onSubmit={handleFormSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    placeholder="Your name"
                    required 
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    placeholder="Your email"
                    required 
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input 
                  type="text" 
                  id="subject" 
                  name="subject" 
                  placeholder="Message subject"
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="5" 
                  placeholder="Your message"
                  required
                ></textarea>
              </div>
              <motion.button 
                type="submit" 
                className="submit-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Send Message
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ContactUs; 